export default "__VITE_PUBLIC_ASSET__c6ac769a__"